import { AHIcon } from "./AHIcon";
import { BoxProps } from "./AHTheme/BoxProps";
import { ColorType } from "./AHTheme/AHTheme";
import { IconSize } from "./LayoutProvider";
import React from "react";

function asertNever(_: never) {
  console.warn("No implementation for todo category icon");
}

export type TodoCategoryIconType = "Check" | "Message" | "Order" | "Sun";
export function AHTodoCategoryIcon(
  props: {
    icon: TodoCategoryIconType;
    color?: ColorType;
    size?: IconSize;
  } & BoxProps
) {
  switch (props.icon) {
    case "Check":
      return <AHIcon type="check" {...props} />;
    case "Message":
      return <AHIcon type="message" {...props} />;
    case "Order":
      return <AHIcon type="truck" {...props} />;
    case "Sun":
      return <AHIcon type="sun" {...props} />;

    default:
      asertNever(props.icon);
      return null;
  }
}
